// @flow
import React from 'react';
import styled from 'styled-components';
import { FlexColumn } from 'styles/Layout';
import { PrimaryButton } from 'styles/Buttons';

const Wrapper = styled(FlexColumn)`
  min-width: 280px;
  margin: 0 auto;
  padding: 0 16px 56px 16px;
`;

const Circle = styled.div`
  display: inline-block;
  height: 165px;
  width: 165px;
  background: #ffffff;
  border-radius: 50%;
  margin-top: 60px;
  margin-bottom: 40px;
  text-align: center;
  position: relative;
  border: 5px solid #278c7e;
`;

const Icon = styled.span`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 86px;
  line-height: 113px;
`;

const Text = styled.p`
  font-size: ${({ size = '14' }) => size}px;
  font-weight: ${({ weight = 'normal' }) => weight};
  margin: ${({ margin = '0px' }) => margin};
  color: ${({ color = '#4a4a4a' }) => color};
  text-align: ${({ align = 'left' }) => align};
`;

const Button = styled(PrimaryButton)`
  width: 200px;
`;

type PropsType = {
  handleClose?: () => void,
  title?: string,
  message?: string
};

export default class SuccessProcess extends React.Component<PropsType, {}> {
  onClickButtonClose = () => {
    this.props.handleClose();
  };

  render() {
    let { title, message } = this.props;
    return (
      <Wrapper alignItems="center">
        <Circle>
          <Icon>👍</Icon>
        </Circle>
        <Text weight="bold" size={25} margin="0 0 10px">
          {title}
        </Text>
        <Text size={20} margin="0 0 40px" align="center">
          {message}
        </Text>
        <Button onClick={this.onClickButtonClose}>Cerrar</Button>
      </Wrapper>
    );
  }
}
